/**
 * The product sounds (F6), the same wavs the desktop embeds
 * (platform/src/sound.rs): join, leave, mute, unmute as one-shot cues, ring
 * as the one looping track, and — D341, D342 — the message tap and the pair
 * around a stream. Vite fingerprints the files from clients/shared/sounds —
 * one source of truth for both clients (D57).
 *
 * Played at unity: every file is mastered to −3 dBFS (sounds/gen.py), so the
 * file's own level is the level. The 0.4 this used to apply, over files that
 * peaked around −11 dBFS, is how the cues came to be reported as too quiet
 * (D340).
 */
import joinUrl from "../../../shared/sounds/join.wav";
import leaveUrl from "../../../shared/sounds/leave.wav";
import muteUrl from "../../../shared/sounds/mute.wav";
import unmuteUrl from "../../../shared/sounds/unmute.wav";
import ringUrl from "../../../shared/sounds/ring.wav";
import messageUrl from "../../../shared/sounds/message.wav";
import streamStartUrl from "../../../shared/sounds/stream_start.wav";
import streamEndUrl from "../../../shared/sounds/stream_end.wav";

const VOLUME = 1.0;

export type Cue = "join" | "leave" | "mute" | "unmute" | "message" | "stream_start" | "stream_end";

const CUES: Record<Cue, string> = {
  join: joinUrl,
  leave: leaveUrl,
  mute: muteUrl,
  unmute: unmuteUrl,
  message: messageUrl,
  stream_start: streamStartUrl,
  stream_end: streamEndUrl,
};

/** Fire-and-forget; autoplay refusals (no gesture yet) are silence, not
 * errors — a sound that cannot play is not worth a notice. */
export function play(cue: Cue): void {
  const el = new Audio(CUES[cue]);
  el.volume = VOLUME;
  void el.play().catch(() => {});
}

let ring: HTMLAudioElement | null = null;

export function ringStart(): void {
  if (ring) return;
  ring = new Audio(ringUrl);
  ring.volume = VOLUME;
  ring.loop = true;
  void ring.play().catch(() => {});
}

export function ringStop(): void {
  ring?.pause();
  ring = null;
}
